import "../assets/index-4ebacc78.css";
import { Dropdown as r } from "floating-vue";
import { createFocusTrap as s } from "focus-trap";
import { g as a } from "../chunks/focusTrap-5d0f71d4.mjs";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const p = {
  name: "NcPopover",
  components: {
    Dropdown: r
  },
  inheritAttrs: !1,
  props: {
    popoverBaseClass: {
      type: String,
      default: ""
    },
    /**
     * Enable popover focus trap
     */
    focusTrap: {
      type: Boolean,
      default: !0
    },
    /**
     * Set element to return focus to after focus trap deactivation
     *
     * @type {import('focus-trap').FocusTargetValueOrFalse}
     */
    setReturnFocus: {
      default: void 0,
      type: [HTMLElement, SVGElement, String, Boolean]
    }
  },
  emits: [
    "after-show",
    "after-hide"
  ],
  beforeDestroy() {
    this.clearFocusTrap(), this.clearEscapeStopPropagation();
  },
  methods: {
    /**
     * @return {HTMLElement|undefined}
     */
    getPopoverContentElement() {
      var e, t;
      return (t = (e = this.$refs.popover) == null ? void 0 : e.$refs.popperContent) == null ? void 0 : t.$el;
    },
    /**
     * Add focus trap for accessibility.
     */
    async useFocusTrap() {
      if (await this.$nextTick(), !this.focusTrap)
        return;
      const e = this.getPopoverContentElement();
      e && (this.$focusTrap = s(e, {
        // Prevents to lose focus using esc key
        // Focus will be release when popover be hide
        escapeDeactivates: !1,
        allowOutsideClick: !0,
        setReturnFocus: this.setReturnFocus,
        trapStack: a()
      }), this.$focusTrap.activate());
    },
    /**
     * Remove focus trap
     *
     * @param {object} options The configuration options for focusTrap
     */
    clearFocusTrap(e = {}) {
      var t;
      try {
        (t = this.$focusTrap) == null || t.deactivate(e), this.$focusTrap = null;
      } catch (o) {
        console.warn(o);
      }
    },
    /**
     * Add stopPropagation for Escape.
     * It prevents global Escape handling after closing popover.
     *
     * Manual event handling is used here instead of v-on because there is no direct access to the node.
     * Alternative - wrap <template #popover> in a div wrapper.
     */
    addEscapeStopPropagation() {
      const e = this.getPopoverContentElement();
      e == null || e.addEventListener("keydown", this.stopKeydownEscapeHandler);
    },
    /**
     * Remove stop Escape handler
     */
    clearEscapeStopPropagation() {
      const e = this.getPopoverContentElement();
      e == null || e.removeEventListener("keydown", this.stopKeydownEscapeHandler);
    },
    /**
     * @param {KeyboardEvent} event - native keydown event
     */
    stopKeydownEscapeHandler(e) {
      e.type === "keydown" && e.key === "Escape" && e.stopPropagation();
    },
    afterShow() {
      this.$nextTick(() => {
        this.$emit("after-show"), this.useFocusTrap(), this.addEscapeStopPropagation();
      });
    },
    afterHide() {
      this.$emit("after-hide"), this.clearFocusTrap(), this.clearEscapeStopPropagation();
    }
  }
};
var i = function() {
  var t = this, o = t._self._c;
  return o("Dropdown", t._g(t._b({ ref: "popover", attrs: { distance: 10, "arrow-padding": 10, "no-auto-focus": !0, "popper-class": t.popoverBaseClass }, on: { "apply-show": t.afterShow, "apply-hide": t.afterHide }, scopedSlots: t._u([{ key: "popper", fn: function() {
    return [t._t("default")];
  }, proxy: !0 }], null, !0) }, "Dropdown", t.$attrs, !1), t.$listeners), [t._t("trigger")], 2);
}, c = [], l = /* @__PURE__ */ n(
  p,
  i,
  c,
  !1,
  null,
  null,
  null,
  null
);
const _ = l.exports;
export {
  _ as default
};
